<template>
  <div class="app-shell">
    <dialog-menu :visible="menuVisible" :items="items" @dismiss="onMenuDismiss"></dialog-menu>
    <header class="app-bar">
      <router-link to="/home" class="bar-brand" title="Beranda">
        <span class="bar-mark"><img src="/brand/kodok-ikon.svg" alt="" width="30" height="30" /></span>
        <span class="bar-wordmark">AccuTrax</span>
        <span v-if="perusahaan" class="bar-company">{{ perusahaan }}</span>
      </router-link>

      <span class="bar-spacer"></span>

      <langganan-chip class="bar-chip" />

      <button type="button" class="bar-btn" title="Panduan Pengguna (tab baru)" @click="onPanduanClick">
        <i class="fa-solid fa-book-open" aria-hidden="true"></i><span class="bar-btn-text">Panduan</span>
      </button>

      <theme-switcher class="bar-theme" />

      <dx-drop-down-button
        :text="user"
        icon="user"
        styling-mode="text"
        :show-arrow-icon="true"
        :items="userMenuItems"
        display-expr="text"
        key-expr="id"
        :element-attr="{ class: 'user-button bar-user' }"
        :drop-down-options="{ width: '180px' }"
      />

      <button type="button" class="bar-btn bar-menu" @click="onMenuClick">
        <i class="fa-solid fa-bars" aria-hidden="true"></i><span class="bar-btn-text">Menu</span>
      </button>
    </header>

    <langganan-banner />

    <main class="app-main">
      <slot></slot>
    </main>
    <div>
      <slot name="footer" />
    </div>

    <langganan-kunci v-if="terkunci" @keluar="onLogoutClick" />
  </div>
</template>

<script>
import ThemeSwitcher from "@/components/theme-switcher.vue";
import LanggananChip from "@/components/langganan-chip.vue";
import LanggananBanner from "@/components/langganan-banner.vue";
import LanggananKunci from "@/components/langganan-kunci.vue";
import { DxDropDownButton } from "devextreme-vue";
import { useAppStore } from "@/stores/app-store";
import appNavigation from "@/app-navigation";
import DialogMenu from "@/dialogs/dialog-menu.vue";
import { sizes } from "@/utils/media-query";
import Helper from "@/helper/helper";

export default {
  name: "AppLayout",
  components: {
    ThemeSwitcher,
    DxDropDownButton,
    DialogMenu,
    LanggananChip,
    LanggananBanner,
    LanggananKunci,
  },
  computed: {
    store() {
      return useAppStore();
    },
    user() {
      return this.store.user ? this.store.user.nama.toUpperCase() : "Guest";
    },
    perusahaan() {
      return this.store.setting?.perusahaan?.nama || "";
    },
    terkunci() {
      return this.store.langgananHabis;
    },
  },
  data() {
    return {
      menuVisible: false,
      items: [],
      userMenuItems: [
        {
          text: "Profil",
          icon: "user",
          onClick: this.onProfileClick,
        },
        {
          text: "Bersihkan penyimpanan",
          icon: "fas fa-trash",
          onClick: this.onClearStorageClick,
        },
        {
          text: "Keluar",
          icon: "runner",
          onClick: this.onLogoutClick,
        },
      ],
    };
  },
  methods: {
    onMenuDismiss() {
      this.menuVisible = false;
    },
    onMenuClick() {
      this.menuVisible = true;
    },
    // Panduan punya layout sendiri di luar aplikasi, jadi dibuka di tab baru dan halaman yang sedang
    // dikerjakan tetap di tempatnya.
    onPanduanClick() {
      window.open(this.$router.resolve({ name: "panduan" }).href, "_blank", "noopener");
    },
    onClearStorageClick() {
      Helper.konfir().then((confirmed) => {
        if (confirmed) {
          localStorage.clear();
        }
      });
    },
    onProfileClick() {
      this.$router.push({
        path: "/profile",
        query: { redirect: this.$route.path },
      });
    },
    onLogoutClick() {
      const redirect = this.$route.path;
      this.store
        .logout()
        .catch((e) => {
          console.error(e);
        })
        .then(() => {
          this.$router.push({
            path: "/login-form",
            query: { redirect },
          });
        });
    },
    bangunMenu() {
      const store = this.store;
      const isLargeScreen = sizes()["screen-large"];
      let navigation = appNavigation;
      const items = navigation.map((item) => {
        if (item.path && !/^\//.test(item.path)) {
          item.path = `/${item.path}`;
        }
        return { ...item, expanded: isLargeScreen };
      });
      for (var x of items) {
        if (x.items) {
          for (var y of x.items) {
            if (y.key != "home") {
              if (store.menuTampil(y)) {
                y.visible = true;
              } else {
                y.visible = false;
              }
            }
          }
          if (x.items.find((item) => item.visible)) {
            x.visible = true;
          } else {
            x.visible = false;
          }
        }
      }
      this.items = items;
    },
  },
  watch: {
    // feature flags arrive after login / start-up: rebuild the menu list
    "store.fitur"() {
      this.bangunMenu();
    },
  },
  mounted() {
    this.bangunMenu();
  },
};
</script>

<style>
.app-shell {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--ground);
}

.app-bar {
  position: sticky;
  top: 0;
  z-index: 1500;
  display: flex;
  align-items: center;
  gap: 6px;
  height: 56px;
  padding: 0 12px 0 14px;
  background: var(--bar);
  color: var(--bar-ink);
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06), 0 6px 16px -10px rgba(11, 79, 79, 0.6);
}

.app-shell .app-bar .bar-brand {
  color: var(--bar-ink);
}
.bar-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  color: inherit;
  text-decoration: none;
  border-radius: 10px;
  padding: 4px 8px 4px 4px;
}
.bar-mark {
  width: 36px;
  height: 36px;
  flex: none;
  border-radius: 10px;
  background: var(--brand-paper);
  display: grid;
  place-items: center;
  overflow: hidden;
}
.bar-mark img {
  width: 34px;
  height: 34px;
  margin-top: 4px;
}
.bar-wordmark {
  font-weight: 700;
  font-size: 18px;
  letter-spacing: -0.02em;
}
.bar-company {
  font-size: 14px;
  color: var(--bar-ink-muted);
  padding-left: 10px;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 32vw;
}
.bar-spacer {
  flex: 1;
}
.bar-chip {
  margin-right: 6px;
}

.bar-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 12px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--bar-ink);
  font: 600 14px/1 var(--font-ui);
  cursor: pointer;
  transition: background-color 140ms ease, transform 140ms var(--ease-out);
}
.bar-btn i {
  font-size: 15px;
}
.bar-btn:active {
  transform: scale(0.97);
}
.bar-menu {
  background: var(--brand-sun);
  color: var(--brand-sun-ink);
  margin-left: 4px;
}
@media (hover: hover) and (pointer: fine) {
  .bar-btn:hover,
  .bar-brand:hover {
    background: var(--bar-hover);
  }
  .bar-menu:hover {
    background: var(--brand-sun-hover);
  }
}

/* DevExtreme di dalam bilah teal: ikon dan teks memakai tinta bilah. */
.app-bar .dx-button-mode-text .dx-icon,
.app-bar .dx-button-mode-text .dx-button-text,
.app-bar .bar-user .dx-button-text,
.app-bar .bar-user .dx-icon {
  color: var(--bar-ink);
}
.app-bar .bar-user .dx-button-text {
  font-weight: 600;
  max-width: 18ch;
  overflow: hidden;
  text-overflow: ellipsis;
}
.app-bar .dx-button-mode-text.dx-state-hover {
  background-color: var(--bar-hover);
}
.app-bar .bar-user .dx-buttongroup-wrapper {
  border-radius: 10px;
}

.app-main {
  flex: 1;
  padding: 12px 16px 8px;
}

@media (max-width: 720px) {
  .app-bar {
    gap: 2px;
    padding: 0 6px 0 8px;
  }
  .bar-wordmark,
  .bar-btn-text,
  .app-bar .bar-user .dx-button-text {
    display: none;
  }
  .bar-company {
    border-left: 0;
    padding-left: 0;
    max-width: 28vw;
  }
  .bar-btn {
    padding: 0 10px;
  }
  .app-main {
    padding: 8px 8px 4px;
  }
}
@media (max-width: 420px) {
  .bar-company {
    display: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .bar-btn:active {
    transform: none;
  }
}
</style>
